<template>
  <div class="button-invoice">
    <button class="button is-primary" @click="clickOpen">인보이스 등록</button>
    <portal to="modal">
      <div class="invoice-modal">
        <sweet-modal ref="modal" width="800px">
          <div class="invoice-modal-title">인보이스 등록</div>
          <div class="invoice-content">
            <admin-form-item label="신청번호" isFlex>
              <div class="size-14 weight-500">{{ item.reference_no }}</div>
            </admin-form-item>
            <admin-form-item label="신청자명" isFlex>
              <div class="size-14 weight-500">{{ item.user.full_name }} ({{ item.user.email }})</div>
            </admin-form-item>
            <admin-form-item label="인보이스 파일">
              <input-single-file :value.sync="value.file" acceptExt=".pdf"></input-single-file>
            </admin-form-item>
            <admin-form-item label="결제 링크">
              <input type="text" class="input" v-model="value.account_link">
            </admin-form-item>
          </div>
          <div class="flex btn-group-justify-end">
            <button class="button" @click="$refs.modal.close()">취소</button>
            <button class="button is-primary" @click="save">저장</button>
          </div>
        </sweet-modal>
      </div>
    </portal>
  </div>
</template>

<script>
  import InputSingleFile from "../../../module/common/InputSingleFile";
  import {SweetModal} from 'sweet-modal-vue';

  export default {
    name: "ButtonInvoice",
    components: {InputSingleFile, SweetModal},
    props: {
      item: {
        type: Object
      }
    },
    data() {
      return {
        value: {
          file: '',
          invoice_link: ''
        }
      }
    },
    methods: {
      clickOpen() {
        this.value = {
          file: '',
          invoice_link: ''
        };
        this.$refs.modal.open();
      },
      save() {
        this.$store.commit('setLoading', true);
        this.$axios.patch(this.getUrl(`shipagency/invoice/${this.item.invoice.id}`), this.value).then(res =>{
          this.item.invoice.file = res.data.file;
          this.item.invoice.invoice_link = this.value.invoice_link;
          this.$store.commit('setLoading', false);
          this.$refs.modal.close();
          this.toast('저장되었습니다.');
        }).catch(()=>{
          this.toast('업로드 중 오류가 발생했습니다.');
          this.$store.commit('setLoading', false);
        })
      }
    }
  }
</script>

<style lang="stylus">
  .invoice-modal
    .sweet-modal.is-alert .sweet-content
      padding 24px
    .invoice-modal-title
      font-size 22px
      font-weight 700
      margin-bottom 24px

</style>
